var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMic16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8 12.667V14m0-1.333c-2.452 0-3.902-1.504-4.657-2.667M8 12.667c2.452 0 3.902-1.504 4.657-2.667m-1.99-5.333v2.666a2.667 2.667 0 0 1-5.334 0V4.667a2.667 2.667 0 0 1 5.334 0"
})));
export default SvgMic16;